import { DealDetail, DealEvent, DealStatus } from 'api'
import { Locale, Translation } from 'locale'
import { getDealStatusColor } from 'view/routes/deals/components/utils'
import * as constants from 'view/styles/constants'

export function getMidTradeEventStatusText(dealDetail: DealDetail) {
  return !dealDetail.isDealHistory ? getLiveMidTradeEventStatusText(dealDetail) : getHistoricalMidTradeEventStatusText(dealDetail)
}

function getLiveMidTradeEventStatusText(dealDetail: DealDetail) {
  return dealDetail.isServicingInitiator
    ? dealDetail.deal.status === DealStatus.SERVICING_WITH_RESPONDER
      ? Locale.translate(Translation.TC_PENDING)
      : Locale.translate(Translation.TC_SECTION_INITIATED)
    : dealDetail.deal.status === DealStatus.SERVICING_WITH_INITIATOR
    ? Locale.translate(Translation.TC_PENDING)
    : Locale.translate(Translation.TC_SECTION_INCOMING)
}

function getHistoricalMidTradeEventStatusText(dealDetail: DealDetail) {
  switch (dealDetail.deal.lastEvent) {
    case DealEvent.SERVICING_SEND:
    case DealEvent.SERVICING_START_TRADER_CANCEL:
      return Locale.translate(Translation.TC_SENT)

    case DealEvent.SERVICING_ACCEPT:
      return Locale.translate(Translation.TC_ACCEPTED)

    case DealEvent.SERVICING_REJECT:
      return Locale.translate(Translation.TC_REJECTED)

    case DealEvent.SERVICING_WITHDRAW:
      return Locale.translate(Translation.TC_WITHDRAWN)

    default:
      return '-- --'
  }
}

export function getMidTradeEventStatusColor(dealDetail: DealDetail, isAdmin: boolean) {
  return !dealDetail.isDealHistory ? getDealStatusColor(dealDetail, isAdmin) : getHistoricalMidTradeEventStatusColor(dealDetail)
}

function getHistoricalMidTradeEventStatusColor(dealDetail: DealDetail) {
  switch (dealDetail.deal.lastEvent) {
    case DealEvent.SERVICING_SEND:
      return constants.STATUS_COLOR_DEFAULT

    case DealEvent.SERVICING_ACCEPT:
      return constants.STATUS_COLOR_ACCEPTED

    case DealEvent.SERVICING_REJECT:
    case DealEvent.SERVICING_WITHDRAW:
      return constants.STATUS_COLOR_URGENT

    default:
      return constants.STATUS_COLOR_DEFAULT
  }
}
